import { useEffect, useRef, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { FiArrowRight, FiCheck, FiHeart, FiInfo, FiShoppingCart, FiX } from "react-icons/fi";

const TYPE_CONFIG = {
    favorite: { Icon: FiHeart, defaultTitle: "Añadido a favoritos" },
    cart: { Icon: FiShoppingCart, defaultTitle: "Añadido al carrito" },
    success: { Icon: FiCheck, defaultTitle: "¡Listo!" },
    info: { Icon: FiInfo, defaultTitle: "" },
};

export const AppToastFixed = (props) => {

    const { show = false, type = "info", title, message, duration = 4500, actionLabel, onAction, onClose } = props;

    const { Icon, defaultTitle } = TYPE_CONFIG[type] || TYPE_CONFIG.info;

    const REF__useRef__timer = useRef(null);
    const REF__useRef__start = useRef(Date.now());
    const REF__useRef__remaining = useRef(duration);

    const [usePaused, setPaused] = useState(false);

    const startTimer = () => {
        REF__useRef__start.current = Date.now();
        REF__useRef__timer.current = setTimeout(() => onClose?.(), REF__useRef__remaining.current);
    };

    const pauseTimer = () => {
        if (REF__useRef__timer.current) {
            clearTimeout(REF__useRef__timer.current);
            REF__useRef__remaining.current -= Date.now() - REF__useRef__start.current;
        }
    };

    useEffect(() => {
        if (!show || duration <= 0) return;
        REF__useRef__remaining.current = duration;
        startTimer();
        return () => clearTimeout(REF__useRef__timer.current);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [show, duration]);

    const handleMouseEnter = () => {
        if (duration <= 0) return;
        pauseTimer();
        setPaused(true);
    };

    const handleMouseLeave = () => {
        if (duration <= 0) return;
        startTimer();
        setPaused(false);
    };

    const handleActionClick = () => {
        onAction?.();
        onClose?.();
    };

    return (
        <>
            <svg className="LStudio__app_content_toast_fixed_svg_defs" aria-hidden width="0" height="0">
                <defs>
                    <linearGradient id="sd-toast-warm-grad" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" stopColor="#F5D547" />
                        <stop offset="50%" stopColor="#FF8E5C" />
                        <stop offset="100%" stopColor="#E85D75" />
                    </linearGradient>
                </defs>
            </svg>

            <div className="LStudio__app_container_toast_fixed" aria-live="polite">
                <AnimatePresence>
                    {
                        show && (
                            <motion.div key="toast" initial={{ opacity: 0, x: -40, scale: 0.95 }}
                                animate={{ opacity: 1, x: 0, scale: 1 }} exit={{ opacity: 0, x: -30, scale: 0.92, transition: { duration: 0.22 } }}
                                transition={{ duration: 0.42, ease: [0.22, 1, 0.36, 1] }} className={`toast_motion_content toast_motion_content_${type}`}
                                onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} role="status">
                                <span className="toast_motion_content_accent" aria-hidden />

                                <span className="toast_motion_content_aura" aria-hidden />

                                <div className="toast_motion_content_content">
                                    <div className="toast_motion_content_icon">
                                        <span className="toast_motion_content_icon-bg" aria-hidden />
                                        <Icon />
                                    </div>

                                    <div className="toast_motion_content_text">
                                        <h5 className="toast_motion_content_title">
                                            {title ?? defaultTitle}
                                        </h5>
                                        {
                                            message && (
                                                <p className="toast_motion_content_message">{message}</p>
                                            )
                                        }
                                        {
                                            actionLabel && (
                                                <button type="button" className="toast_motion_content_action" onClick={handleActionClick}  >
                                                    <span>{actionLabel}</span>
                                                    <FiArrowRight />
                                                </button>
                                            )
                                        }
                                    </div>

                                    <button type="button" className="toast_motion_content_close LStudio__app_close_control" onClick={onClose} aria-label="Cerrar notificación" >
                                        <FiX />
                                    </button>
                                </div>

                                {
                                    duration > 0 && (
                                        <div className="toast_motion_content_progress" aria-hidden>
                                            <span className="toast_motion_content_progress-fill"
                                                style={{
                                                    animationDuration: `${duration}ms`, animationPlayState: usePaused ? "paused" : "running",
                                                }}
                                            />
                                        </div>
                                    )
                                }
                            </motion.div>
                        )
                    }
                </AnimatePresence>
            </div>
        </>
    );
};